{
  "version": 1,
  "note": "画面の並びの定義 (eq-server の [layout] file で差し替えられる)。書式は docs/ui-spec/layout-system.html の「定義ファイル」。上から順に、when に最初に合うものを使う",
  "subMap": {
    "note": "右上のサブの地図 (試験定義 trial)。最後の情報から hold の時間ははっきり、過ぎたら fadedAlpha の濃さから fadeSec 秒かけて薄くして消す。震度は 10=1, 20=2, 30=3, 40=4, 45=5弱, 50=5強, 55=6弱, 60=6強, 70=7",
    "hold": [
      {"maxScale": 20, "sec": 60},
      {"maxScale": 40, "sec": 180},
      {"maxScale": 50, "sec": 600},
      {"sec": 900}
    ],
    "unknownSec": 180,
    "fadedAlpha": 0.4,
    "fadeSec": 120
  },
  "layouts": [
    {
      "name": "landscape",
      "note": "横向きのスマホ (幅 801 以上・高さ 480 以下。高さの低い PC のウィンドウも)。高さが足りないので、帯を地図の左上に重ねる札にする (EEW は 1 件ずつ巡回)。別枠と凡例は横に並べる。案内と通知は時計と重ならないよう左下へ。上部バーは細く (CSS)",
      "when": {"minWidth": 801, "maxHeight": 480},
      "root": {
        "dir": "column",
        "children": [
          {"slot": "topbar", "size": "auto"},
          {
            "box": "layout",
            "dir": "row",
            "size": "fill",
            "children": [
              {
                "slot": "main",
                "size": "fill",
                "overlays": {
                  "top-left": {
                    "flow": "column",
                    "items": [
                      {"slot": "banners", "variant": "compact"},
                      {"flow": "row", "items": ["inset", "legend", "caption"]},
                      "countdown"
                    ]
                  },
                  "bottom-left": {"flow": "column", "items": ["toast", "hint"]},
                  "bottom-right": {"flow": "column", "items": ["ogasawara", "clock"]}
                }
              },
              {
                "box": "side",
                "dir": "column",
                "size": "300px",
                "children": [
                  {"slot": "settings", "size": "auto"},
                  {"slot": "detail", "size": "auto"},
                  {"slot": "history-head", "size": "auto"},
                  {"slot": "history", "size": "fill"},
                  {"slot": "notice", "size": "fill"},
                  {"slot": "credit", "size": "auto"}
                ]
              }
            ]
          }
        ]
      }
    },
    {
      "name": "regular",
      "note": "PC (幅 801 以上)。地図 + 右パネル 380px。別枠の右に天気の札の案内、その下にカウントダウン (別枠が隠れれば上に詰まる)",
      "when": {"minWidth": 801},
      "root": {
        "dir": "column",
        "children": [
          {"slot": "topbar", "size": "auto"},
          {"slot": "banners", "size": "auto"},
          {
            "box": "layout",
            "dir": "row",
            "size": "fill",
            "children": [
              {
                "slot": "main",
                "size": "fill",
                "overlays": {
                  "top-left": {"flow": "column", "items": [{"flow": "row", "items": ["inset", "caption"]}, "countdown"]},
                  "bottom-left": {"flow": "column", "items": ["legend"]},
                  "bottom-right": {"flow": "column", "items": ["ogasawara", "clock"]},
                  "bottom": {"flow": "column", "items": ["toast", "hint"]}
                }
              },
              {
                "box": "side",
                "dir": "column",
                "size": "380px",
                "children": [
                  {"slot": "settings", "size": "auto"},
                  {"slot": "detail", "size": "auto"},
                  {"slot": "history-head", "size": "auto"},
                  {"slot": "history", "size": "fill"},
                  {"slot": "notice", "size": "fill"},
                  {"slot": "credit", "size": "auto"}
                ]
              }
            ]
          }
        ]
      }
    },
    {
      "name": "compact",
      "note": "スマホ縦 (幅 800 以下)。縦に積み、ページ全体がスクロール。別枠の右に案内、下に凡例 (地図が細いと凡例が九州に重なるため)。カウントダウンは時計の上に積む (横に並べると時計と重なる)。案内と通知は時計と重ならないよう左下へ (案内は CSS で幅を絞って 2 行)",
      "when": {"maxWidth": 800},
      "scroll": "page",
      "root": {
        "dir": "column",
        "children": [
          {"slot": "topbar", "size": "auto"},
          {"slot": "banners", "size": "auto"},
          {
            "box": "layout",
            "dir": "column",
            "size": "auto",
            "children": [
              {
                "slot": "main",
                "size": "60svh",
                "overlays": {
                  "top-left": {"flow": "column", "gap": "8px", "items": [{"flow": "row", "gap": "4px", "minHeight": "140px", "items": ["inset", "caption"]}, "legend"]},
                  "bottom-right": {"flow": "column", "pad": "6px", "items": ["ogasawara", "countdown", "clock"]},
                  "bottom-left": {"flow": "column", "items": ["toast", "hint"]}
                }
              },
              {
                "box": "side",
                "dir": "column",
                "size": "auto",
                "children": [
                  {"slot": "settings", "size": "auto"},
                  {"slot": "detail", "size": "auto"},
                  {"slot": "history-head", "size": "auto"},
                  {"slot": "history", "size": "auto"},
                  {"slot": "notice", "size": "auto"},
                  {"slot": "credit", "size": "auto"}
                ]
              }
            ]
          }
        ]
      }
    },
    {
      "name": "trial",
      "note": "試験中。?layout=trial で選ぶ。JDQ の画面の形 (左: 全国の地図 + 下の帯 / 右: 右上はサブの地図 (最近の地震) + パネル群)。幅 800 以下 (スマホ縦) と高さ 480 以下 (横向きのスマホ) では選ばれず、自動の定義になる",
      "manual": true,
      "when": {"minWidth": 801, "minHeight": 481},
      "root": {
        "dir": "column",
        "children": [
          {"slot": "topbar", "size": "auto"},
          {
            "box": "layout",
            "dir": "row",
            "size": "fill",
            "children": [
              {
                "dir": "column",
                "size": "fill",
                "children": [
                  {
                    "slot": "main",
                    "size": "fill",
                    "overlays": {
                      "top-left": {"flow": "column", "items": [{"slot": "banners", "variant": "compact"}, {"flow": "row", "items": ["inset", "caption"]}, "countdown"]},
                      "bottom-left": {"flow": "column", "items": ["legend"]},
                      "bottom-right": {"flow": "column", "items": ["ogasawara"]},
                      "bottom": {"flow": "column", "items": ["toast", "hint"]}
                    }
                  },
                  {
                    "dir": "row",
                    "size": "22%",
                    "children": [
                      {"slot": "clock", "size": "auto"},
                      {"slot": "notice", "size": "fill"}
                    ]
                  }
                ]
              },
              {
                "box": "side",
                "dir": "column",
                "size": "fill",
                "children": [
                  {"slot": "settings", "size": "auto"},
                  {"slot": "map-sub", "size": "40%"},
                  {"slot": "detail", "size": "auto"},
                  {"slot": "eew-panel", "size": "auto"},
                  {"slot": "history-head", "size": "auto"},
                  {"slot": "history", "size": "fill"},
                  {"slot": "credit", "size": "auto"}
                ]
              }
            ]
          }
        ]
      }
    },
    {
      "name": "broadcast",
      "note": "配信 (native の eq-broadcast) の平時の並び。今の配信の絵に合わせた px。上部バーの直後に気象警報の帯の専用の場所 banners (2 行ぶんの 50px) を取り、地図と右の列はその下から始まる。?layout=broadcast で web でも見られる (自動では選ばれない)。配信は起動時にこの定義を読む",
      "manual": true,
      "when": {"minWidth": 801, "minHeight": 481},
      "root": {
        "dir": "column",
        "children": [
          {"slot": "topbar", "size": "36px"},
          {"slot": "banners", "size": "50px"},
          {
            "box": "layout",
            "dir": "row",
            "size": "fill",
            "children": [
              {
                "slot": "main",
                "size": "fill",
                "overlays": {
                  "top-left": {"flow": "column", "items": ["inset"]},
                  "bottom-left": {"flow": "column", "items": ["legend"]},
                  "bottom-right": {"flow": "column", "items": ["ogasawara", "clock"]}
                }
              },
              {
                "box": "side",
                "dir": "column",
                "size": "380px",
                "children": [
                  {"slot": "detail", "size": "144px"},
                  {"slot": "history", "size": "fill"},
                  {"slot": "notice", "size": "138px"},
                  {"slot": "credit", "size": "90px"}
                ]
              }
            ]
          }
        ]
      }
    },
    {
      "name": "broadcast-quake",
      "note": "配信の地震の画面の並び。broadcast と main・topbar・banners・出典は同じで、右の列は上から 詳細 / サブの地図 (列の約 44%) / 履歴 (残りの高さ。52px の行が入る件数だけ描く) / 出典。お知らせは置かない。サブの地図を使わない設定 (sub_map = false) の配信は、この定義を使わず broadcast の矩形で描く。?layout=broadcast-quake で web でも見られる",
      "manual": true,
      "when": {"minWidth": 801, "minHeight": 481},
      "root": {
        "dir": "column",
        "children": [
          {"slot": "topbar", "size": "36px"},
          {"slot": "banners", "size": "50px"},
          {
            "box": "layout",
            "dir": "row",
            "size": "fill",
            "children": [
              {
                "slot": "main",
                "size": "fill",
                "overlays": {
                  "top-left": {"flow": "column", "items": ["inset"]},
                  "bottom-left": {"flow": "column", "items": ["legend"]},
                  "bottom-right": {"flow": "column", "items": ["ogasawara", "clock"]}
                }
              },
              {
                "box": "side",
                "dir": "column",
                "size": "380px",
                "children": [
                  {"slot": "detail", "size": "154px"},
                  {"slot": "map-sub", "size": "300px"},
                  {"slot": "history", "size": "fill"},
                  {"slot": "credit", "size": "90px"}
                ]
              }
            ]
          }
        ]
      }
    }
  ]
}
